<!--
  ~ Copyright (c) 2025.
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
  -->

<div class="filterrij">
  <div class="row">
    <div class="col">
      <label for="filterniveau" class="form-label">Niveau</label>
      <select id="filterniveau" class="form-select" [(ngModel)]="filter.niveau" (change)="doeFilter()">
        <option [ngValue]="null"></option>
        @for (niveau of niveaus; track niveau) {
          <option [value]="niveau">{{ niveau }}</option>
        }
      </select>
    </div>
    <div class="col">
      <label for="filtersector" class="form-label">Sector</label>
      <select id="filtersector" class="form-select" [(ngModel)]="filter.sector" (change)="doeFilter()">
        <option [ngValue]="null"></option>
        @for (sector of sectoren; track sector) {
          <option [value]="sector">{{ sector }}</option>
        }
      </select>
    </div>
    <div class="col">
      <label for="filterprofiel" class="form-label">Profiel</label>
      <select id="filterprofiel" class="form-select" [(ngModel)]="filter.profielkeuze" (change)="doeFilter()">
        <option [ngValue]="null"></option>
        @for (profielkeuze of profielkeuzes; track profielkeuze) {
          <option [value]="profielkeuze">{{ profielkeuze }}</option>
        }
      </select>
    </div>
    <div class="col">
      <label for="filterdisc" class="form-label">DISC</label>
      <select id="filterdisc" class="form-select" [(ngModel)]="filter.disc" (change)="doeFilter()">
        <option [ngValue]="null"></option>
        @for (disc of discs; track disc) {
          <option [value]="disc">{{ disc }}</option>
        }
      </select>
    </div>
    <div class="col importbtncol">
      <input #fileimportctrl id="import" type="file" hidden
             accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
             name="excelfile"
             (change)="startImport($event)">
      <button id="importeerbtn" class="btn btn-primary" (click)="fileimportctrl.click()">Importeer...</button>
      <small class="ms-2">Een Excel bevat de mogelijke studierichtingen voor één niveau (WO of HBO). Als je een nieuwe
        Excel voor een niveau importeert, vervang je <em>alle</em> gegevens voor dat niveau in de studielijst. Na
        inladen wordt eerst een samenvatting getoond, je kan dan nog terug.</small>
    </div>
  </div>

</div>
<div class="wpaiska_studietable_container">
  <table #studietable class="table table-striped table-bordered table-hover">
    <thead>
    <tr>
      <th>Niveau</th>
      <th>Sector</th>
      <th>Studierichting</th>
      @for (disc of discs; track disc; let nr = $index) {
        @if (nr % 7 === 0) {
          <th class="wpaipska_lucht"></th>
        }
        <th class="wpaipska_disc">{{ disc }}</th>
      }
      <th class="wpaipska_lucht"></th>
      @for (pk of profielkeuzes; track pk) {
        <th class="wpaipska_profielkeuze">{{ pk }}</th>
      }
    </tr>
    </thead>
    <tbody>
      @for (studie of studiesGefilterd; track studie.id; let rijnr = $index; ) {
        <tr [title]="studie.studierichting" (click)="selectedRijNr = rijnr"
            [class.wpaipska_select]="selectedRijNr === rijnr">
          <td class="wpaipska_niveau">{{ studie.niveau }}</td>
          <td class="wpaipska_sector">{{ studie.sector }}</td>
          <td class="wpaipska_studierichting" [innerHTML]="breakStudierichting(studie)"></td>
          @for (disc of discs; track disc; let nr = $index) {
            @if (nr % 7 === 0) {
              <td class="wpaipska_lucht"></td>
            }
            <td class="wpaipska_disc">@if (studie['d_' + disc]) {
              X
            }</td>
          }
          <td class="wpaipska_lucht"></td>
          @for (pk of profielkeuzes; track pk) {
            <td class="wpaipska_profielkeuze">{{ magProfielkeuze(studie, pk) }}</td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
<div class="wpaipska_textcenter">
  N.B. deze lijst is op geen enkele wijze bindend en geeft slechts een indicatie van passende studierichtingen.
    Controleer altijd de eisen van de opleiding.
</div>
